import {
    Box,
    Button,
    CssBaseline,
    Paper,
    TextField,
    useMediaQuery,
} from "@mui/material";
import React, { ChangeEvent, FocusEvent, useEffect, useLayoutEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { MuiTelInput } from "mui-tel-input";
import style from "./LoginPage.module.scss";
import { TabsType } from "../../../types/PublicPages/LoginPage.types";
import { useAuthStore } from "../../../store/auth.store";
import SlideImage3 from "./images/image1.jpg";
import { useSnackbar } from "notistack";
import { throwError, throwErrorText } from "../../../hooks/useErrorHandler";
import { Loading } from "../../../utils/components/Loading";
import { Link } from "react-router-dom";

export function LoginPage() {
    const { login, setUserBrowserData, accessToken, logout, refresh } = useAuthStore();
    const [currentTab, setCurrentTab] = useState<TabsType>(TabsType.EMAIL);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState({
        email: "",
        password: "",
        phone: "",
    });

    const isMobile = useMediaQuery("(max-width:700px)");

    const [loading, setLoading] = useState(false);

    // Проверка авторизации и редирект на главную страницу, если авторизован
    const [loadingIsAuth, setLoadingIsAuth] = useState(false)
    useLayoutEffect(() => {
        (async () => {
            try {
                setLoadingIsAuth(true)
                if (accessToken) {
                    const isAuthed = await refresh();
                    console.log(isAuthed)
                    if (isAuthed) location.href = "/admin"
                }
            } catch (error) {
                logout()
            } finally {
                setLoadingIsAuth(false)
            }
        })();
    }, [])

    useEffect(() => {
        setUserBrowserData(navigator.userAgent);
    }, []);

    if (loadingIsAuth) return <Box sx={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }}><Loading /></Box>

    const handleChangeTabs = (event: React.SyntheticEvent, value: any) => {
        setPhoneNumber("");
        setPassword("");
        setEmail("");
        setCurrentTab(value);
    };

    const handleChangePhone = (value: string) => {
        setPhoneNumber(value);
        const correct =
            /(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/.test(
                "8" + value.split(" ").join("")
            );
        if (!correct)
            setError({ ...error, phone: "Некорретный номер телефона" });
        else setError({ ...error, phone: "" })
    };

    const handleChangeEmail = (
        data: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setEmail(data.target.value);
        const correct = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.target.value);
        if (!correct) setError({ ...error, email: "Некорректный email" });
        else setError({ ...error, email: "" })
    };

    const handleChangePassword = (event: any) => {
        setPassword(event.target.value);
    };

    const handleLogin = async () => {
        if ((email == "" && phoneNumber == "") || password == "")
            return throwErrorText("Не все поля заполнены верно");
        if (currentTab == TabsType.EMAIL ? error.email != "" : error.password != "" || error.phone != "")
            return throwErrorText("Не все поля заполнены верно");
        setLoading(true);
        try {
            await login(
                currentTab == TabsType.EMAIL ? email : phoneNumber,
                password
            );
        } catch (error: any) {
            throwError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleFocus = (
        event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setError({ ...error, [event.target.name]: "" });
    };

    const handleBlur = (
        event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        if (event.target.name == "email") {
            const correct = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                event.target.value
            );
            if (!correct) setError({ ...error, email: "Некорректный email" });
        }
        if (event.target.name == "phone") {
            const correct =
                /(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/.test(
                    "8" + event.target.value.split(" ").join("")
                );
            if (!correct)
                setError({ ...error, phone: "Некорретный номер телефона" });
        }
    };

    return (
        <div className={style.container}>
            <CssBaseline />
            <Paper
                className={style.menu}
                sx={{
                    minHeight: "100%",
                    minWidth: isMobile ? "100%" : "416px",
                }}
            >
                <h1>Вход в кабинет</h1>
                <Tabs value={currentTab} onChange={handleChangeTabs}>
                    <Tab value="email" label="Email" />
                </Tabs>
                {currentTab == "email" && (
                    <div className={style.tab__content}>
                        <TextField
                            error={error.email != ""}
                            id="email"
                            name="email"
                            label=""
                            defaultValue=""
                            placeholder="admin@admin.com"
                            value={email}
                            onChange={handleChangeEmail}
                            type="email"
                            helperText={error.email}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                        />
                        <TextField
                            error={error.password != ""}
                            id="password"
                            name="password"
                            label=""
                            defaultValue=""
                            placeholder="Пароль"
                            value={password}
                            onChange={handleChangePassword}
                            type="password"
                            helperText={error.password}
                        />
                        <Link to="/resetpassword" className={style.forgot__password}>
                            Забыли пароль?
                        </Link>
                        <Button
                            variant="contained"
                            onClick={handleLogin}
                            disabled={loading}
                        >
                            Войти
                        </Button>
                        <a href="mailto:mail@ikm-group.ru" className={style.tech__link}>
                            Написать в тех. поддержку
                        </a>
                    </div>
                )}
            </Paper>
            {!isMobile && (
                <div className={style.mySwiper}>
                    <img src={SlideImage3} alt="Authorization Screen" style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%"
                    }} />
                </div>
            )}
        </div>
    );
}
